<template>
  <v-row
      align="center"
      justify="center"
  >
    <v-col
        cols="12"
        sm="8"
        md="4"
    >
      <v-card outlined :loading="loading">
        <v-toolbar
            flat
        >
          <v-toolbar-title>Log into your account</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="loginUser"
        >
          <v-card-text class="pb-0">
            <v-alert
                text
                type="success"
                v-if="showEmailVerifiedAlert"
            >
              Successfully verified!
            </v-alert>
            <v-alert
                text
                type="success"
                v-if="passwordResetAlert"
            >
              Successfully reset password!
            </v-alert>
            <v-alert
                text
                prominent
                color="primary"
                icon="priority_high"
                v-if="error!=''"
            >
              <v-row align="center">
                <v-col class="grow">{{ error }}</v-col>
              </v-row>
            </v-alert>
            <v-text-field
                label="Email"
                name="email"
                prepend-inner-icon="mdi-account"
                outlined
                type="text"
                v-model="email"
                :rules="emailRules"
                required
                :validate-on-blur="isFirstSubmissionAttempt"
            ></v-text-field>
            <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-inner-icon="mdi-lock"
                outlined
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                :rules="passwordRules"
                required
            ></v-text-field>
            <div class="text-right">
              <v-btn
                  color="grey"
                  text
                  to="/forgotPassword"
                  large
                  class="text-body-2 text-right mt-n8 pa-1"
              >
                Forgot password?
              </v-btn>
            </div>
            <v-btn elevation="0" block type="submit" color="primary" large class="text-body-1 mt-4">Log In</v-btn>
            <v-btn elevation="0" color="grey lighten-2" block outlined @click="loginWithGoogle" large
                   class="text-body-1 mt-4 mb-4">
              <v-img src="@/assets/google-logo.png" aspect-ratio="1" max-width="50" height="30px" contain></v-img>
              <div class="text-body-2 grey--text text--darken-1">Log In with Google</div>
            </v-btn>
            <v-btn elevation="0" color="black" block @click="loginWithApple" large class="text-body-1 mt-4 mb-4">
              <v-img src="@/assets/apple-logo-white.png" aspect-ratio="1" max-width="50" height="30px" contain></v-img>
              <div class="text-body-2 white--text">Log In with Apple</div>
            </v-btn>
          </v-card-text>
        </v-form>
      </v-card>
      <!-- <v-row class="mt-8">
        <v-spacer></v-spacer>
          <div class="text-center text-body-1 grey--text">Don't have an account? <a :href="pricingUrl" class="text-decoration-none font-weight-medium"><span>Sign up</span></a></div>
        <v-spacer>
        </v-spacer>
      </v-row> -->
    </v-col>
  </v-row>
</template>
<script>
// @ is an alias to /src

import {mapActions, mapGetters} from 'vuex'
import Utility from '@/shared/utility';
import {GoogleAuthProvider, OAuthProvider, signInWithEmailAndPassword, signInWithPopup} from 'firebase/auth';
import {updateUserDoc, getAuth} from "@/shared/firebase_utils";


export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: '',
      loading: false,
      showPassword: false,
      valid: false,
      isFirstSubmissionAttempt: true,
      emailRules: [
        v => !!v || 'Please enter your email',
        v => /.+@.+\..+/.test(v) || 'Invalid email',
      ],
      passwordRules: [
        v => !!v || 'Please enter your password',
      ],
      showEmailVerifiedAlert: false,
      passwordResetAlert: false,
      auth: getAuth(),
    }
  },
  methods: {
    async loginUser() {
      this.showEmailVerifiedAlert = false;
      this.passwordResetAlert = false;
      if (this.$refs.form.validate()) {
        this.loading = true;

        signInWithEmailAndPassword(this.auth, this.email, this.password).then(async (responseData) => {
          //User registered successfully
          //Use the responseData object to get related inormation
          //Redirect user to the home page
          await this.redirectAfterSuccessfullLogin(responseData.user.uid);
        }).catch((err) => {
          // Handle Errors here.
          // var errorCode = err.code;
          // var errorMessage = err.message;
          this.error = err.message
          this.loading = false;
        });
      } else {
        this.isFirstSubmissionAttempt = false;
        this.error = '';
      }
    },
    async updateUserHostPlatformDetails(uid) {
      try {
        await updateUserDoc(uid, {
          lastLoginDate: new Date(),
          lastLoggedInPlatform: 'business-portal',
          hasLoggedInToBusinessPortal: true,
        });

      } catch (error) {
        console.log(error);
      }
    },
    async redirectAfterSuccessfullLogin(uid) {
      try {
        let switchToBusinessProfileId = this.$route.query.switchToBusinessProfileId || '';
        let plan = this.$route.query.plan || '';
        let upgradeToBusinessPlan = this.$route.query.upgradeToBusinessPlan || false;


        // //Get the user from firestore
        // let user = await firebase.firestore().collection('users').doc(uid).get();
        // //Get the business_portal_access documents for this user from firestore
        // let businessPortalAccess = await firebase.firestore().collection('business_portal_access').where('uid', '==', uid).get();
        // console.log("Retrieved business_portal_access documents for this user from firestore: ", businessPortalAccess.docs.length);
        // //Check if there is atleast one business_portal_access document for this user where the status is 'active'
        // let hasActiveBusinessPortalAccess = businessPortalAccess.docs.some(doc => doc.data().status == 'active' && doc.data().businessName != '' && doc.data().businessName != null && doc.data().businessName != undefined);
        // console.log("hasActiveBusinessPortalAccess: ", hasActiveBusinessPortalAccess);
        // //If there is no business_portal_access document for this user where the status is 'active', then set the error message and return
        // if (!hasActiveBusinessPortalAccess) {
        //   this.error = "You do not have access to the business portal. Please contact your administrator.";
        //   this.loading = false;
        //   return;
        // }

        this.updateUserHostPlatformDetails(uid);

        if (plan != '') {
          await updateUserDoc(uid, {subscriptionPreference: this.getSubscriptionPlanFromQueryString(plan)});
        }
        if (upgradeToBusinessPlan != '') {
          await updateUserDoc(uid, {upgradeToBusinessPlan: upgradeToBusinessPlan});
        }
        if (switchToBusinessProfileId != '') {
          this.$router.push({name: 'BusinessAccounts', query: {switchToBusinessProfileId: switchToBusinessProfileId}});
        } else {
          this.$router.replace('/');
        }
      } catch (err) {
        // Handle Errors here.
        // var errorCode = err.code;
        // var errorMessage = err.message;
        this.error = err.message
        this.loading = false;
      }
    },
    async loginWithGoogle() {
      if (this.loading == true)
        return;
      try {

        this.loading = true;
        this.error = "";
        const provider = new GoogleAuthProvider();
        let result = await signInWithPopup(this.auth, provider);
        const user = result.user;
        if (result.additionalUserInfo.isNewUser) {
          await user.delete();
          this.error = "User not found.";
          this.loading = false;
        } else
          await this.redirectAfterSuccessfullLogin(user.uid);
      } catch (error) {
        // this.error = error.message;
        this.loading = false;
      }

    },
    async loginWithApple() {
      if (this.loading == true)
        return;
      try {
        this.loading = true;
        this.error = "";
        const provider = new OAuthProvider('apple.com');

        let result = await signInWithPopup(this.auth, provider);
        const user = result.user;
        if (result.additionalUserInfo.isNewUser) {
          await user.delete();
          this.error = "User not found.";
          this.loading = false;
        } else
          await this.redirectAfterSuccessfullLogin(user.uid);
      } catch (error) {
        // this.error = error.message;
        this.loading = false;
      }
    },
    signUpLink() {
      if (this.$route.query.plan != undefined)
        return '/register?plan=' + this.$route.query.plan;
      else
        return '/register';
    }
  },
  created() {
    this.getSubscriptionPlanFromQueryString = Utility.getSubscriptionPlanFromQueryString;
    this.showEmailVerifiedAlert = this.$route.query.emailVerfied || false;
    this.passwordResetAlert = this.$route.query.passwordReset || false;
  },
  computed: {
    ...mapGetters(['userProfile', 'pricingUrl']),
  }
}
</script>
